"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parkYourTruckAvailabilityRecordSchema = void 0;
const zod_1 = require("zod");
exports.parkYourTruckAvailabilityRecordSchema = zod_1.z.object({
    id: zod_1.z.string(),
    siteId: zod_1.z.string(),
    numberOfParkingSpots: zod_1.z.number().nonnegative(),
    availableParkingSpots: zod_1.z.number().nonnegative(),
    timestamp: zod_1.z.string(),
});
//# sourceMappingURL=parkyourtruck.js.map